import DOMUtils from "@utils/dom.utils";

export default {
  SELECTOR: {
    STP: ".teacher-stp",
    STP_TAG: ".teacher-stp:not(.stp-component)",
    STP_COMPONENT: ".teacher-stp.stp-component",
    STP_COMPONENT_WRAPPER: ".sls-stp-wrapper",
  },

  /**
   * Function to create STP tag.
   * @param stpData
   * @returns {HTMLElement}
   */
  createStpTag(stpData) {
    let activeTab = stpData.activeTab;
    let teachingActionId = stpData.teachingActionId;
    let teachingActionName = stpData.teachingActionName;
    let teachingActionUrl = stpData.teachingActionUrl;
    let teachingActionNotes = stpData.teachingActionNotes;

    let stpTagElement = document.createElement("span");
    stpTagElement.setAttribute("class", "richtext-tooltip teacher-stp noneditable");
    stpTagElement.setAttribute("data-active-tab", activeTab);
    stpTagElement.setAttribute("data-teaching-action-id", teachingActionId);
    stpTagElement.setAttribute("data-teaching-action-name", teachingActionName);
    stpTagElement.setAttribute("data-teaching-action-url", teachingActionUrl);
    stpTagElement.setAttribute("data-note", teachingActionNotes);

    return stpTagElement;
  },

  /**
   * Function extract the STP data from Stp tooltip tag and component.
   * @param element
   * @returns {*}
   */
  retrieveDataFromStpTooltip(element) {
    if (notDefined(element) || isNull(element)) {
      return {};
    }

    const data = {
      activeTab: element.getAttribute("data-active-tab"),
      teachingActionId: element.getAttribute("data-teaching-action-id"),
      teachingActionName: element.getAttribute("data-teaching-action-name"),
      teachingActionUrl: element.getAttribute("data-teaching-action-url"),
      teachingActionNotes: element.getAttribute("data-note"),
    };

    // legacy data does not contain URL as data attribute
    if (!data.teachingActionUrl) {
      // case of legacy data: have to extract from the "original-title" data attribute instead.
      const tooltipContent = element.getAttribute("data-original-title");
      data.teachingActionUrl = this.extractUrlFromToolTipContent(tooltipContent);
    }

    // Note: intentional comparison with strings "undefined" and "null"
    if (data.teachingActionId === "undefined" || data.teachingActionId === "null") {
      data.teachingActionId = null;
    }
    if (data.teachingActionUrl === "undefined" || data.teachingActionUrl === "null") {
      data.teachingActionUrl = null;
    }

    return data;
  },

  /**
   * Function to extract Teaching Action URL from legacy data.
   * Expected structure: `<a href="{url to extract}"></a><div>...</div>`
   * @param content
   * @returns {*}
   */
  extractUrlFromToolTipContent(content) {
    if (notDefined(content) || isNull(content)) {
      // invalid content
      return null;
    }

    const container = document.createElement("div");
    container.innerHTML = content;

    const teachingActionLink = DOMUtils.elOf(container, "a")[0];
    if (notDefined(teachingActionLink)) {
      // cannot find link element
      return null;
    }

    let teachingActionUrl = teachingActionLink.getAttribute("href");
    if (
      notDefined(teachingActionUrl) ||
      teachingActionUrl === "undefined" ||
      teachingActionUrl === "null"
    ) {
      // no URL
      return null;
    }

    return teachingActionUrl;
  },

  /**
   * Function to retrieve the first STP in editor's selection.
   * @param editor
   * @returns {*}
   */
  retrieveFirstSelectedStpFromEditor(editor) {
    // find in selection start
    const selectionStart = editor.selection.getStart();
    if (DOMUtils.hasClass(selectionStart, "sls-stp-wrapper")) {
      return DOMUtils.elOf(selectionStart, this.SELECTOR.STP_COMPONENT)[0];
    }

    // find in selection content
    const selection = editor.selection.getSel();
    const container = editor.selection.getNode();
    const stpInSelection = DOMUtils.elOf(container, this.SELECTOR.STP_COMPONENT).filter((node) => {
      return selection.containsNode(node);
    });
    if (stpInSelection.length !== 0) {
      return stpInSelection[0];
    }

    // find in selection end
    const selectionEnd = editor.selection.getEnd();
    if (DOMUtils.hasClass(selectionEnd, "sls-stp-wrapper")) {
      return DOMUtils.elOf(selectionEnd, this.SELECTOR.STP_COMPONENT)[0];
    }

    // no selection or STP not in selection
    return null;
  },
};
